var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "600px" },
      on: { input: _vm.openEditorHandler },
      model: {
        value: _vm.showEditor,
        callback: function ($$v) {
          _vm.showEditor = $$v
        },
        expression: "showEditor",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "accent" },
        [
          _c(
            "v-card-title",
            {
              staticStyle: {
                "background-color": "#47bd96",
                color: "white",
                "letter-spacing": "0.03rem",
                height: "40px",
              },
              style: _vm.$vuetify.breakpoint.xsOnly
                ? "text-align: center !important;"
                : "",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.editMode ? `Edit ${_vm.tenantData.name}` : "Add Tenant"
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "12" } },
                        [
                          _c("v-text-field", {
                            ref: "tenantName",
                            attrs: {
                              label: "Name",
                              filled: "",
                              outlined: "",
                              dense: "",
                              required: "",
                              rules: [_vm.rules.required],
                            },
                            model: {
                              value: _vm.localTenantData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.localTenantData, "name", $$v)
                              },
                              expression: "localTenantData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "12" } },
                        [
                          _c(
                            "input-wrapper-2",
                            {
                              attrs: {
                                label: "Parent",
                                info: "Select a parent Tenant for which you want to link the tenant to.",
                                "label-background-light": "#D2E2DE",
                                "label-background-dark": "#162627",
                                dense: "",
                                "full-width": "",
                              },
                            },
                            [
                              _c("v-select", {
                                ref: "selectParentTenantInput",
                                staticStyle: { width: "100%", margin: "4px 0" },
                                attrs: {
                                  items: _vm.parentSelectOptions,
                                  "item-text": "name",
                                  "item-value": "id",
                                  placeholder: "Select Tenant",
                                  dense: "",
                                  filled: "",
                                  solo: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.localTenantData.parent,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localTenantData, "parent", $$v)
                                  },
                                  expression: "localTenantData.parent",
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.localTenantData.parent = null
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#d50101" } },
                                    [_vm._v(" fas fa-times ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "12" } },
                        [
                          _c(
                            "input-wrapper2",
                            {
                              attrs: {
                                label: "Properties",
                                "container-class": "properties-cont",
                                "full-width": "",
                                flex: "",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "properties-list" },
                                [
                                  !!_vm.localTenantData.properties
                                    ? _vm._l(
                                        _vm.localTenantData.properties,
                                        function (value, key) {
                                          return _c(
                                            "div",
                                            {
                                              key: `property-key-${key}`,
                                              staticClass: "property-item",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ml-6" },
                                                [_vm._v(_vm._s(key))]
                                              ),
                                              _c("div", [_vm._v(" :")]),
                                              _c("div", [
                                                _vm._v(_vm._s(value)),
                                              ]),
                                              _c("v-spacer"),
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "no-results" },
                                          [_vm._v("No Properties found!")]
                                        ),
                                      ],
                                  _c(
                                    "div",
                                    { staticClass: "new-property" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "new-property__key" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              filled: "",
                                              placeholder: "key",
                                              dense: "",
                                              "hide-details": "",
                                              width: "24px",
                                            },
                                            model: {
                                              value: _vm.propertyEntry.key,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.propertyEntry,
                                                  "key",
                                                  $$v
                                                )
                                              },
                                              expression: "propertyEntry.key",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" : "),
                                      _c(
                                        "div",
                                        { staticClass: "new-property__value" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              filled: "",
                                              placeholder: "value",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.propertyEntry.value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.propertyEntry,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "propertyEntry.value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            text: "",
                                            dense: "",
                                          },
                                          on: { click: _vm.addPropertyHandler },
                                        },
                                        [_vm._v(" + Add ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "property-error" }, [
                                _vm._v(_vm._s(_vm.propertyError)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { plain: "" }, on: { click: _vm.closeEditorHandler } },
                [_vm._v("Cancel")]
              ),
              _c(
                "span",
                { on: { mouseenter: _vm.touchError } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: !_vm.canSave,
                        loading: _vm.loading,
                      },
                      on: { click: _vm.saveTenantHandler },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(!!_vm.editMode ? "Save" : "Add") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }